unit uCommonStuff;
//***
//*** This material is a confidential Trade Secret belonging to David P. Schwartz and VBB Media ***
//
// FILE: uEpisodeManager.pas
// VERSION: 1.3
// CREATED: 6/19/26

interface

uses
  System.SysUtils, System.Classes, Types, JS, Web,
  WEBLib.Graphics, WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ComCtrls, WEBLib.ExtCtrls, WEBLib.Lists,
  WEBLib.REST, WEBLib.JSON, WEBLib.Buttons; //, VCL.TMSFNCSwitch, WEBLib.Storage;

type
  TPanelButton = TWebPanel; // a panel used as a button

  TStepRange = 1..9;  // for Plant numbering

  TWebComboBoxHelper = class helper for TWebComboBox
    function GetSelectedItem: integer;
    procedure SetSelectedItem(const Value: integer);
    property SelectedItem : integer read GetSelectedItem write SetSelectedItem;
    procedure SelectFirstItem;
  end;

  TWebTabSheetHelper = class helper for TWebTabSheet
    [async] procedure ShowPage;
  end;
(*
  TTMSFNCSwitchHelper = class helper for TTMSFNCSwitch
    procedure SetBoolState(const Value: boolean);
    function isOn : boolean;
    function isOff : boolean;
    property BoolState : boolean write SetBoolState;
  end;
*)
  TWebListControlHelper = class helper for TWebListControl
    procedure AddText( const aStr : string );
  end;

  // this is to make the grid act more like a list
  TWebStringGridHelper = class helper for TWebStringGrid
    procedure Clear;
    procedure AddText( const aStr : string );
    procedure AddStrings( aStrings : TStrings );
  end;

  [async] procedure DoSleep_async( aMsecs : integer );
//  [async] procedure _DoSleep( aMsecs : integer );
  [async] function AsyncSleep(ms: NativeInt): TJSPromise;

  [async] procedure ShowPage( aPage : TWebTabSheet );

  function ToPrettyJSON( const aJSONpkt : string ) : string;

  function  TimeSpanToStr( aStartDT, aEndDT : TDateTime ) : string;
  function  ExtractVideoID(const aURL: string): string;


  // put ReqdXxxx inside of a Try...Except clause as they raise exceptions
  // eg: DOB := ReqdString( aDOB_edt.Text, 'DOB' );
  // if it's not empty, it will be filled
  // if it IS empty, it will raise an exception that needs to be caught
  // we might want to change the 2nd field to be a TWinControl for more flexibility
  function  ReqdString( const aStr, aFldNm : string; const aErrMsg : string='' ) : string;

  // This throws an exception
  procedure AssertNotEmpty(const aValue, aContext: string);

  function _JSON_VAL_STR( aJObj  : TJSONObject; const aKey : string; const aDflt : string='' ) : string; inline;
  function _JSON_VAL_INT(aJObj   : TJSONObject; const aKey: string; const aDflt: Integer = 0): Integer; inline;
  function _JSON_VAL_FLOAT(aJObj : TJSONObject; const aKey: string; const aDflt: Double = 0): Double; inline;
  function _JSON_VAL_OBJ( aJObj  : TJSONObject; const aKey : string ) : TJSONValue; inline;
  function _JSON_VAL_ARR( aJObj  : TJSONObject; const aKey: string ): TJSONArray; inline;

implementation

uses System.DateUtils, System.TimeSpan; //, uLockerFactory;

// these need to be inside of a Try...Except block to trap errors
// if there's no problem, then it returns the specified type
// otherwise it raises an exception
function ReqdString( const aStr, aFldNm : string; const aErrMsg : string='' ) : string;
var msg : string;
begin
  Result := Trim(aStr);
  if (Result = '') then
  begin
    msg := 'A non-empty value is required for '+aFldNm;
    if (aErrMsg <> '') then
      msg := msg + '. ' + aErrMsg;
    raise Exception.Create(msg)
  end;
end;

// the AssertXxxx throw exceptions
procedure AssertNotEmpty(const aValue, aContext: string);
begin
  if Trim(aValue) = '' then
    raise Exception.Create(aContext + ': input is empty');
end;

// ---------------------------------------------------------------------------
// JSON helpers
// ---------------------------------------------------------------------------

function _JSON_VAL_STR(aJObj: TJSONObject; const aKey: string; const aDflt: string=''): string; inline;
var v: TJSONValue;
begin
  v := aJObj.GetValue(aKey);
  if (v = nil) then Result := aDflt else Result := v.Value;
end;

function _JSON_VAL_INT(aJObj: TJSONObject; const aKey: string; const aDflt: Integer=0): Integer; inline;
var v: TJSONValue;
begin
  v := aJObj.GetValue(aKey);
  if (v = nil) then Result := aDflt else Result := StrToIntDef(v.Value, aDflt);
end;

function _JSON_VAL_FLOAT(aJObj: TJSONObject; const aKey: string; const aDflt: Double=0): Double; inline;
var v: TJSONValue;
begin
  v := aJObj.GetValue(aKey);
  if (v = nil) then Result := aDflt else Result := StrToFloatDef(v.Value, aDflt);
end;

function _JSON_VAL_OBJ(aJObj: TJSONObject; const aKey: string): TJSONValue; inline;
var v: TJSONValue;
begin
  v := aJObj.GetValue(aKey);
  if (v <> nil) and (not (v is TJSONNull)) then
    Result := v as TJSONObject
  else
    Result := TJSONObject.Create;
end;

function _JSON_VAL_ARR(aJObj: TJSONObject; const aKey: string): TJSONArray; inline;
var
  v     : TJSONValue;
  parts : TStringList;
  i     : integer;
begin
  v := aJObj.GetValue(aKey);
  if (v = nil) then
    Result := TJSONArray.Create
  else if v is TJSONArray then
    Result := v as TJSONArray
  else
  begin
    Result := TJSONArray.Create;
    parts := TStringList.Create;
    parts.StrictDelimiter := True;
    parts.CommaText := TJSONString(v).Value;
    for i := 0 to parts.Count-1 do
      Result.Add(Trim(parts[i]));
  end;
end;

//===============================================================
function ToPrettyJSON( const aJSONpkt : string ) : string;
//===============================================================
begin
  Result := TJSJSON.Stringify(TJSJSON.Parse(aJSONpkt), nil, 2);
end;

//===============================================================
function ExtractVideoID(const aURL: string): string;
//===============================================================
var
  p : integer;
  s : string;
begin
  Result := '';
  s := aURL;

  // youtu.be/VIDEO_ID
  p := Pos('youtu.be/', s);
  if (p > 0) then
  begin
    s := Copy(s, p + 9, 999);
    p := Pos('?', s);
    if (p > 0) then s := Copy(s, 1, p-1);
    Result := Trim(s);
    Exit;
  end;

  // youtube.com/watch?v=VIDEO_ID
  p := Pos('v=', s);
  if (p > 0) then
  begin
    s := Copy(s, p + 2, 999);
    p := Pos('&', s);
    if (p > 0) then s := Copy(s, 1, p-1);
    Result := Trim(s);
  end;
end;

//===============================================================
function TimeSpanToStr( aStartDT, aEndDT : TDateTime ) : string;
//===============================================================
var
  msecs : integer;
  str   : string;
  TS    : TTimeSpan;
begin
  msecs := MilliSecondsBetween(aEndDT, aStartDT);
  TS := TTimeSpan.FromMilliseconds(msecs);
  Result := Format( '%.2d.%.3d', [TS.Minutes*60+TS.Seconds, TS.Milliseconds] );
end;

//===============================================================
procedure ShowPage( aPage : TWebTabSheet );
//===============================================================
begin
  aPage.ShowPage;
end;

//===============================================================
procedure DoSleep_async( aMsecs : integer );
//===============================================================
begin
  AsyncSleep( aMsecs );
end;

//procedure _DoSleep( aMsecs : integer );
//begin
//  Await(boolean, AsyncSleep(aMsecs));
//end;

//===============================================================
function AsyncSleep(ms: NativeInt): TJSPromise;
//===============================================================
begin
  Result := TJSPromise.New(
  procedure(resolve,reject : TJSPromiseResolver)
  begin
    window.setTimeout(
    procedure()
    begin
      resolve(ms);
    end,
    ms);
  end);
end;


//===============================================================
procedure TWebTabSheetHelper.ShowPage;
//===============================================================
var
  pc : TWebPageControl;
begin
  pc := TWebPageControl(Parent);
  pc.TabIndex := PageIndex;
  if (pc.Parent is TWebTabSheet) then
    TWebTabSheet(pc.Parent).ShowPage;
end;

{ TTMSFNCSwitchHelper }
(*
//===============================================================
function TTMSFNCSwitchHelper.isOff: boolean;
//===============================================================
begin
  Result := State = ssOff;
end;

//===============================================================
function TTMSFNCSwitchHelper.isOn: boolean;
//===============================================================
begin
  Result := State = ssOn;
end;

//===============================================================
procedure TTMSFNCSwitchHelper.SetBoolState(const Value: boolean);
//===============================================================
begin
  if Value then State := ssOn else State := ssOff;
end;
*)
{ TWebComboBoxHelper }

//===============================================================
function TWebComboBoxHelper.GetSelectedItem: integer;
//===============================================================
begin
  Result := ItemIndex;
end;

//===============================================================
procedure TWebComboBoxHelper.SelectFirstItem;
//===============================================================
begin
  SetSelectedItem(0);
end;

//===============================================================
procedure TWebComboBoxHelper.SetSelectedItem(const Value: integer);
//===============================================================
begin
  ItemIndex := Value;
  OnChange(self);
end;

{ TWebListControlHelper }

//===============================================================
procedure TWebListControlHelper.AddText(const aStr: string);
//===============================================================
var
  li : TListItem;
begin
  li := Items.Add;
  li.Text := aStr;
end;

{ TWebStringGridHelper }

//===============================================================
procedure TWebStringGridHelper.Clear;
//===============================================================
var
  c, r : integer;
begin
  for c := 0 to ColCount-1 do
    for r := 0 to RowCount-1 do
      Cells[c,r] := '';
  RowCount := 1;
end;

//===============================================================
procedure TWebStringGridHelper.AddText(const aStr: string);
//===============================================================
var
  r : integer;
begin
  if (RowCount = 1) and (Cells[0,0] = '') then
    Cells[0,0] := aStr
  else begin
    r := RowCount;
    RowCount := r+1;
    Cells[0,r] := aStr;
  end;
end;

//===============================================================
procedure TWebStringGridHelper.AddStrings(aStrings: TStrings);
//===============================================================
var
  r0, r : integer;
begin
  r0 := RowCount;
  BeginUpdate;
  RowCount := RowCount + aStrings.Count;
  for r := r0 to RowCount-1 do
    Cells[0,r] := '';
  EndUpdate;
end;

end.
